import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/site";

const Card = ({ s, index }) => (
  <motion.a
    href="#contact"
    data-testid={`service-card-${s.title.toLowerCase().replace(/\s/g, "-")}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (index % 2) * 0.1 }}
    className={`group relative flex min-h-[340px] flex-col justify-end overflow-hidden border border-white/10 bg-secondary md:min-h-[420px] ${s.span}`}
  >
    <div className="absolute inset-0">
      <img
        src={s.img}
        alt={s.title}
        className="h-full w-full object-cover opacity-45 grayscale transition-all duration-700 group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
    </div>

    <div className="absolute left-6 top-6 flex items-center gap-4">
      <span className="font-mono-tech text-xs text-primary">{s.id}</span>
      <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
        {s.tag}
      </span>
    </div>

    <div className="absolute right-6 top-6 flex h-11 w-11 items-center justify-center border border-white/20 text-foreground transition-colors group-hover:border-primary group-hover:bg-primary group-hover:text-primary-foreground">
      <ArrowUpRight className="h-5 w-5" />
    </div>

    <div className="relative z-10 p-6 md:p-8">
      <h3 className="font-display text-4xl uppercase tracking-tight md:text-5xl">{s.title}</h3>
      <p className="mt-3 max-w-md text-sm text-muted-foreground">{s.blurb}</p>
    </div>
  </motion.a>
);

export const Services = () => {
  return (
    <section id="services" className="relative bg-background py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <div className="mb-4 flex items-center gap-3 font-mono-tech text-[11px] uppercase tracking-[0.3em] text-primary">
              <span className="inline-block h-2 w-2 bg-primary" /> What we service
            </div>
            <h2 className="max-w-2xl font-display text-5xl uppercase leading-[0.9] tracking-tight md:text-7xl">
              Repairs &amp; upkeep <br />
              <span className="text-muted-foreground">done right.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-muted-foreground">
            Service only — we don't install. That means every visit is focused on
            fixing, tuning, and protecting the system you already have.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
          {SERVICES.map((s, i) => (
            <Card key={s.id} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
